import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { computed } from 'mobx';

export class ProductListDataService extends DataService<typeof Model.Products.Logic.ViewModels.ProductSummary, Model.Products.Logic.ViewModels.ProductSummary, ProductSummary> {
	protected map(entity: Model.Products.Logic.ViewModels.ProductSummary): ProductSummary {
		return new ProductSummaryModel(entity);
	}

	static make(ctx?: any): ProductListDataService {
		return new ProductListDataService(ctx, ctx => ctx.ProductSummaries);
	}
}

export class ProductSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.ProductSummary, ProductSummary> implements ProductSummary {
	@property<ProductSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ProductSummaryModel>(o => o.entity.code, (o, value) => o.entity.code = value)
	public code: string;

	@property<ProductSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<ProductSummaryModel>(o => o.entity.productType, (o, value) => o.entity.productType = value)
	public productType: Model.Core.Models.ProductType;
	@property<ProductSummaryModel>(o => o.entity.isLeaf, (o, value) => o.entity.isLeaf = value)
	public isLeaf: boolean;
	@computed
	public get productTypeText(): string {
		switch (this.entity.productType) {
			case 0:
				return 'General';
			case 1:
				return 'Accomodation';
			case 2:
				return 'Car rent';
			case 3:
				return 'Transfer';
			case 4:
				return 'Flight';
			case 5:
				return 'Room';
			case 6:
				return 'Supplement/Discount';
			case 7:
				return 'Sales Adjustment';
			case 8:
				return 'Accounting Adjustment';
			case 9:
				return 'Tour';
			case 10:
				return 'Package';
		}
		return null;
	}

	@property<ProductSummaryModel>(o => o.entity.categoryDisplayName, (o, value) => o.entity.categoryDisplayName = value)
	public categoryDisplayName: string;

	@property<ProductSummaryModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<ProductSummaryModel>(o => o.entity.parentProductId, (o, value) => o.entity.parentProductId = value)
	public parentProductId?: number;

	@property<ProductSummaryModel>(o => o.entity.stopSales, (o, value) => o.entity.stopSales = value)
	public stopSales?: Date;

	@property<ProductSummaryModel>(o => o.entity.denyCurrencyConversion, (o, value) => o.entity.denyCurrencyConversion = value)
	public denyCurrencyConversion: boolean;

	@property<ProductSummaryModel>(o => o.entity.regionId, (o, value) => o.entity.regionId = value)
	public regionId: number;

	@property<ProductSummaryModel>(o => o.entity.regionDisplayName, (o, value) => o.entity.regionDisplayName = value)
	public regionDisplayName: string;

	@property<ProductSummaryModel>(o => o.entity.placeId, (o, value) => o.entity.placeId = value)
	public placeId: number;

	@property<ProductSummaryModel>(o => o.entity.placeDisplayName, (o, value) => o.entity.placeDisplayName = value)
	public placeDisplayName: string;

	@property<ProductSummaryModel>(o => o.entity.location, (o, value) => o.entity.location = value)
	public location: Geography;

	@property<ProductSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
	public hasChildren: boolean;

	@property<ProductSummaryModel>(o => o.entity.parentDisplayName, (o, value) => o.entity.parentDisplayName = value)
	public parentDisplayName: string;
}



// WEBPACK FOOTER //
// ./src/app/products/products/list/product-list.data.ts